


















































































































import _ from 'lodash';
import mixins from 'vue-typed-mixins';
import { editName, START_LOADING, END_LOADING, TABLE_DATA, TABLE_SCHEMA } from '@/main/store/listEditTypes';
import { getStavZakazka } from '@/modules/servis/zakazka/utils';
import { genVuexComputeds } from '@/main/pages/editFactory';

import { makeInjector } from '@/main/utils/vue';

import Vue from 'vue';

import { UserRole } from '@/main/components/constants';

import { apiProvider as ozakazkaProvider } from '../../../ozakazka/api';

import { Tabs, UzivatelskeNotifikace } from '../../components';
import { EditMixin } from '../../mixins/editMixin';
import EditLayout from '../../EditLayout.vue';
import VozidloSelect from '../../components/microcomponents/VozidloSelect.vue';
import ZakaznikSelect from '../../components/microcomponents/ZakaznikSelect.vue';
import WorkflowButtons from '../../components/WorkflowButtons.vue';
import PracovnikSelect from '../../components/microcomponents/PracovnikSelect.vue';
import HlavniKarta from './HlavniKarta.vue';
import { NAME, ZAKAZKA_ND, PRACOVNI_POZICE, SERVICE_JOB_DETAILS, OwnerContactTypeId } from './constants';

import { MENU_CODE, TAB_NAMES, TABS, ZAKAZKA_STAV } from '../../constants';


const collectionPropInjector = makeInjector<{ mainPageRefresh(): void }>();

export default mixins(EditMixin, collectionPropInjector(Vue, ['mainPageRefresh'])).extend({
	name: editName(NAME),
	components: {
		PracovnikSelect,
		VozidloSelect,
		EditLayout,
		HlavniKarta,
		ZakaznikSelect,
		Tabs,
		UzivatelskeNotifikace,
		WorkflowButtons,
	},
	data() {
		return {
			localOrderSubtypeId: null as number | null,
		}
	},
	computed: {
		isUserServiceAdvisorOrCre(): boolean {
			return this.pracovnik.PracovnikOzn === (UserRole.SERVICE_ADVISER) || this.pracovnik.PracovnikOzn === (UserRole.CRE);
		},
		zakaznikExists() {
			return this.ZakaznikId! > 0;
		},
		
		tabItems() {
			const tabItems = [];

			if (this.hasTabAccess(MENU_CODE, TABS.Hlavni)) tabItems.push(TAB_NAMES.HLAVNI);
			if (this.hasTabAccess(MENU_CODE, TABS.AddvancePay)) tabItems.push(TAB_NAMES.ADVANCEPAY);
			if (this.hasTabAccess(MENU_CODE, TABS.Prac)) tabItems.push(TAB_NAMES.PRAC);
			if (this.hasTabAccess(MENU_CODE, TABS.CiziVykonySlevyKorekce)) tabItems.push(TAB_NAMES.CIZI_VYKONY_SLEVY_KOREKCE);
			if (!(getStavZakazka(this.edit) === ZAKAZKA_STAV.NABIDKA) && this.hasTabAccess(MENU_CODE, TABS.ZapujckyRef)) tabItems.push(TAB_NAMES.ZAPUJCKY_REF);
			if (this.hasTabAccess(MENU_CODE, TABS.Kalkulace)) tabItems.push(TAB_NAMES.KALKULACE);
			if (this.hasTabAccess(MENU_CODE, TABS.Zalohy)) tabItems.push(TAB_NAMES.ZALOHY);
			if (this.hasTabAccess(MENU_CODE, TABS.Vydejky)) tabItems.push(TAB_NAMES.VYDEJKY);
			if (this.dmsSys.StoreRequisitionFormPrp && this.hasTabAccess(MENU_CODE, TABS.ReserveParts)) tabItems.push(TAB_NAMES.PARTS_RESERVE);
			if (this.hasTabAccess(MENU_CODE, TABS.History)) tabItems.push(TAB_NAMES.HISTORY);
			if (this.hasTabAccess(MENU_CODE, TABS.Poznamky)) tabItems.push(TAB_NAMES.POZNAMKY);
			if (this.hasTabAccess(MENU_CODE, TABS.Zarazeni)) tabItems.push(TAB_NAMES.ZARAZENI);
			if (this.hasTabAccess(MENU_CODE, TABS.ZakazkyRef)) tabItems.push(TAB_NAMES.ZAKAZKY_REF);
			if (this.hasTabAccess(MENU_CODE, TABS.Reference)) tabItems.push(TAB_NAMES.REFERENCE);
			if (this.hasTabAccess(MENU_CODE, TABS.GDPR)) tabItems.push(TAB_NAMES.GDPR);
			if (this.hasTabAccess(MENU_CODE, TABS.PlanSkutecnost)) tabItems.push(TAB_NAMES.PLAN_SKUTECNOST);
			if (this.hasTabAccess(MENU_CODE, TABS.Doklady)) tabItems.push(TAB_NAMES.DOKLAD);
			if (this.hasTabAccess(MENU_CODE, TABS.OSC)) tabItems.push(TAB_NAMES.ZAKAZKY_OSC);
			if (this.hasTabAccess(MENU_CODE, TABS.CustomerFeedback)) tabItems.push(TAB_NAMES.CUSTOMER_FEEDBACK);
			if (this.hasTabAccess(MENU_CODE, TABS.HealthCard)) tabItems.push(TAB_NAMES.HEALTH_CARD);
			if (this.hasTabAccess(MENU_CODE, TABS.Saga2)) tabItems.push(TAB_NAMES.SAGA_2);
			if (this.hasTabAccess(MENU_CODE, TABS.Saga2Komunikace)) tabItems.push(TAB_NAMES.SAGA_2_KOMUNIKACE);

			return _.pick(TABS, tabItems);
		},
	},
	inject: {
		mainPageRefresh: 'refreshPage',
	},
	created() {
		this.localOrderSubtypeId = this.OrderSubtypeId === null ? 0 : this.OrderSubtypeId;
		if (this.ContactTypeId && this.CustomerContactDetails) {
			const selectedDetail = this.CustomerContactDetails.find((detail: any) => detail.ContactTypeId === this.ContactTypeId);
			if (selectedDetail) {
				this.SelectedCustomerContactDetail = selectedDetail;
			} else {
				const defaultOwnerDetail = this.CustomerContactDetails.find((detail: any) => detail.ContactTypeId === OwnerContactTypeId);
				if (defaultOwnerDetail) {
					this.ContactTypeId = OwnerContactTypeId;
					this.SelectedCustomerContactDetail = defaultOwnerDetail;
				}
			}
        }
	},
	methods: {
		clearLeasingValidate() {
			this.$nextTick(() => {
				(this.$refs.zakazkaEditLayout as HTMLFormElement).mainForm.clearValidate('LeaszakaznikId');
			});
		},
		async fetchTableData(this: any, tablesToFetch: string[] = Object.values(this.zakazkaTables)): Promise<any> {
			const tables: [string, any][] = tablesToFetch.map((item) => [item, item]);
			return Promise.all(tables.map(([key, value]) => this.$store.dispatch(`${this.storeUri}/${value}_${TABLE_DATA}`, { filter: this[`${value}Filter`] })));
		},
		tabClicked(tab: any) {
			this.$emit('tab-click', tab);
		},
		async contactTypeChange(value: any) {
            if (value && this.CustomerContactDetails) {
                const selectedDetail = this.CustomerContactDetails.find((detail: any) => detail.ContactTypeId === value);                
				this.SelectedCustomerContactDetail = selectedDetail || null;
            }
        }
	},
});
